import { render, staticRenderFns } from "./ModalDivider.vue?vue&type=template&id=cbfb3388&"
import script from "./ModalDivider.vue?vue&type=script&lang=js&"
export * from "./ModalDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports